import { connect } from "react-redux";

import GlobalVerticalChart from "../../components/visualizations/global_vertical_chart";
import { countryChanged } from "../../actions/filters";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.verticalChart)) { return {}; }

  const dataAndOptions = ld.verticalChart;
  const highlightCountry = state.main.filters.country.selectedValue ? state.main.filters.country.selectedValue.value : null;
  const title = `Countries by combined ${state.main.filters.year.selectedValue.value} tariff`;

  return { dataAndOptions, highlightCountry, title };
};

const mapDispatchToProps = dispatch => ({
  onChange: (e) => {
    e.preventDefault();
    e.stopPropagation();

    const text = e.target.innerText;
    dispatch(countryChanged({ value: text, label: text }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalVerticalChart);

